import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ErrorLocations } from '../common/interfaces';
import { PREVIEW_PURCHASE } from '../gql/queries';
import { captureError, Severity, TeamInfo } from '@chegg/observability';
import { APOLLO_COMMERCE_CONTEXT } from '../gql/constants';
/**
 * Map of plans that have a free trial to the plan that should be used for the preview
 * This is because the preview summary is 0 for free trial plans in the preview purchase
 * and we want to show the actual plan. There is feature request filed (https://chegg.atlassian.net/browse/VBC-105)
 * to recurly to fix this. Till that time this is a hacky workaround
 */
var FREE_TRIAL_PLANS_MAP = [{
  originalPlanCode: 'bib1m3dft_base',
  currency: 'USD',
  mappedPlanCode: 'cw1mnft_base'
}, {
  originalPlanCode: 'cw1m3dft_base',
  currency: 'USD',
  mappedPlanCode: 'cw1mnft_base'
}, {
  originalPlanCode: 'cm1m3dft_base',
  currency: 'USD',
  mappedPlanCode: 'cw1mnft_base'
}, {
  originalPlanCode: 'bm1m3dft_base',
  currency: 'USD',
  mappedPlanCode: 'cw1mnft_base'
}];

/**
 * Returns the preview of a Recurly purchase
 */
var getRecurlyPreviewPurchase = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _FREE_TRIAL_PLANS_MAP;
    var planCode, currency, couponCode, countryCode, postalCode, uuid, apolloClient, planCodeToUse, _yield$apolloClient$m, data;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          planCode = _ref.externalId, currency = _ref.currency, couponCode = _ref.couponCode, countryCode = _ref.countryCode, postalCode = _ref.postalCode, uuid = _ref.uuid, apolloClient = _ref.apolloClient;
          planCodeToUse = ((_FREE_TRIAL_PLANS_MAP = FREE_TRIAL_PLANS_MAP.find(function (_ref3) {
            var originalPlanCode = _ref3.originalPlanCode,
              currencyCode = _ref3.currency;
            return planCode === originalPlanCode && currency === currencyCode;
          })) === null || _FREE_TRIAL_PLANS_MAP === void 0 ? void 0 : _FREE_TRIAL_PLANS_MAP.mappedPlanCode) || planCode;
          _context2.prev = 2;
          _context2.next = 5;
          return apolloClient.mutate({
            mutation: PREVIEW_PURCHASE,
            variables: {
              previewPurchaseInput: _objectSpread(_objectSpread({}, countryCode && {
                billingAddress: {
                  country: countryCode,
                  postalCode: postalCode
                }
              }), {}, {
                currency: currency,
                planCode: planCodeToUse,
                promotionCode: couponCode ? [couponCode] : null
              })
            },
            context: _defineProperty({
              headers: {
                'X-CHEGG-USER-UUID': uuid
              }
            }, APOLLO_COMMERCE_CONTEXT, true)
          });
        case 5:
          _yield$apolloClient$m = _context2.sent;
          data = _yield$apolloClient$m.data;
          return _context2.abrupt("return", data.previewPurchase);
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](2);
          captureError({
            error: _context2.t0,
            severity: Severity.CRITICAL,
            location: ErrorLocations.RECURLY_PREVIEW_PURCHASE
          }, {
            UserUuid: uuid,
            teamName: TeamInfo['FT-CommerceWeb'].name
          });
          return _context2.abrupt("return", null);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[2, 10]]);
  }));
  return function getRecurlyPreviewPurchase(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default getRecurlyPreviewPurchase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getRecurlyPreviewPurchase.js
// module id = 4136
// module chunks = 11